import './table.scss';

export function IconButton({ icon, additionalStyles = '', onClick, disabled }) {
  return (
    <button type='button' className={`icon_btn ${additionalStyles}`} onClick={onClick} disabled={disabled}>
      {icon}
    </button>
  );
}
